import { CircleX, Search } from "lucide-react";
import { ISearchInput } from "../../interfaces";

export const GaSearchInput = (props: ISearchInput) => {
    const { id, value, placeholder = "", ariaLabel = "", onChange, onKeyDown, inputRef, autoComplete = "off", dataTestId, tabIndex, additionalClassNames = "" } = props;
 
    return (
        <>
            <div className="ga-form-field ar-ga-form-field">
                <input
                    id={id}
                    ref={inputRef}
                    type="search"
                    placeholder={placeholder}
                    className="ga-input ar-ga-search-input ar-ga-left-icon-input ar-ga-right-icon-input"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onKeyDown={onKeyDown}
                    aria-label={ariaLabel}
                    autoComplete={autoComplete}
                    data-testid={dataTestId}
                    tabIndex={tabIndex}
                />

                <span className="ar-ga-search-icon">
                    <Search size={24} color="var(--ga-color-icon-primary)" />
                </span>
                {value && value.length > 0 &&
                    <span className="ar-ga-clear-search-icon" onClick={() => onChange("")}>
                        <CircleX size={16} color="var(--ga-color-icon-primary)" />
                    </span>
                }
            </div>
        </>
    );
};
